"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const GameBanner = () => {
  const pathname = usePathname();

// Mostrar SOLO en la home
  if (pathname !== "/") return null;

  return (
    <div className="bg-emerald-500 text-white py-4 px-4 text-center flex flex-row justify-center items-center gap-4 flex-wrap">
      <p className="font-semibold text-lg sm:text-xl">
        🎉 Now play and win Seozast subscriptions!
      </p>
      <Link
        href="/freelancer-developer-game"
        className="text-black font-semibold text-md sm:text-lg hover:underline hover:text-black bg-white px-4 py-2 rounded-md shadow-md transition-transform hover:scale-105"
      >
        Play Now
      </Link>
    </div>
  );
};

export default GameBanner;
